module.exports = __webpack_public_path__ + "img/canvas-bg3.ec29104d.png";